export function getStreamChatUserId(userId: number) {
	return userId.toString();
}

export function getStreamChatBusinessTeamName(businessId: number) {
	return `business_${businessId}`;
}
